import React, { useContext, useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import ActionTypes from '@utils/deviceActions';
import { IDevice } from '@pages/Assets/Inventory/types';
import { useTranslation } from 'react-i18next';
import SessionContext from '@providers/Session/SessionContext';

interface HlrReprogPayloadProps {
  action: ActionTypes.HLR_REPROG;
  devices: {
    msisdn: string;
  }[];
}

const MAX_NUM_OF_DEVICES = 20;

interface HlrReprogProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useHlrReprog = ({
  devices,
  isUpload,
}: HlrReprogProps): DeviceActionProps => {
  const { t } = useTranslation('device-actions-modal');
  const { isMot } = useContext(SessionContext);

  const payloadToSend = useMemo(
    (): HlrReprogPayloadProps => ({
      action: ActionTypes.HLR_REPROG,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    payloadToSend,
    confirmDisabled: devices?.length > MAX_NUM_OF_DEVICES,
    infoMessage: isMot && (
      <>
        <p style={{ margin: 0, fontWeight: 'bold' }}>
          {t('just-algar-lines')?.toUpperCase()}
        </p>
        {`${t('max-num-of-devices')}: `}

        <span style={{ opacity: 0.8, fontWeight: 'bold', fontSize: '0.9rem' }}>
          {t('num-of-devices', { count: MAX_NUM_OF_DEVICES })}
        </span>
      </>
    ),
  };
};

export default useHlrReprog;
